const home = () => import(/* webpackChunkName: "web004/home" */ './pages/home/index.vue');
const AISuperviseSystem = () => import(/* webpackChunkName: "supervisePlatform" */ './pages/AISuperviseSystem/index.vue');
const anoahPlatform = () => import(/* webpackChunkName: "anoahPlatform" */ './pages/AnoahPlatform/index.vue');
const contactUs = () => import(/* webpackChunkName: "contactUs" */ './pages/ContactUs/contactUs.vue');

export default [
    {
        path: '/web004/home',
        name: 'Web004',
        component: home,
        meta: {
            disableValidation: true,
        },
    },
    {
        path: '/web004/AISuperviseSystem',
        name: 'AISuperviseSystem',
        component: AISuperviseSystem,
        meta: {
            disableValidation: true,
        },
    },
    {
        path: '/web004/anoahPlatform',
        name: 'AnoahPlatform',
        component: anoahPlatform,
        meta: {
            disableValidation: true,
        },
    },
    {
        path: '/web004/contactUs',
        name: 'ContactUs',
        component: contactUs,
        meta: {
            disableValidation: true,
        },
    },
];
